import { createFileRoute } from '@tanstack/react-router';
import {
  dynamicRuleDetailScreen,
  dynamicRuleDetailSearch,
  loadDynamicRulesMessages,
  loadDynamicRulesScreens,
} from '@/modules/dynamic-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/regras-dinamicas/$ruleId/')({
  validateSearch: dynamicRuleDetailSearch,
  staticData: { screen: dynamicRuleDetailScreen },
  loader: () => loadDynamicRulesMessages(),
  component: lazyScreen(loadDynamicRulesScreens, 'DynamicRuleFormPage'),
});
